<template>
  <div class="login-container">
    <header>
      <a href="https://hmc.co.il/" target="_blank">
        <img class="logo" src="assets/img/svg/logo-blue.svg" alt="logo" />
      </a>
      <div class="header-actions">
        <a
          href="https://hmc.co.il/"
          target="_blank"
          class="lg:only-up head-back-desk flex items-center p-1 gap-2 text-lg border-b-2 border-aqua"
        >
          <img src="assets/img/svg/arrow-right-blue.svg" alt="back" /> חזרה לאתר
          הראשי
        </a>
      </div>
    </header>

    <div class="login-main-container">
      <div class="login-inner-container">
        <LoginForm @changeStep="stepChanged" />

        <Terms />
      </div>

      <img
        class="login-background"
        src="assets/img/layout/login-background.png"
      />
    </div>
  </div>
  <!-- <div>
    <header class="header">
      <div class="head_inner relative flex flex--center">
        <div class="logo">
          <router-link to="/">
            <LOGO></LOGO>
          </router-link>
        </div>
      </div>
    </header>
    <transition name="fade">
      <section
        v-if="loaded"
        class="sec_enter home_enter flex over--hide"
        data-animation="fadeIn"
        data-animated-duration="1s"
        data-animated-delay=".5s"
      >
        <div
          class="
            home_right
            center
            wrap--height
            col--50
            m-100
            flex flex--column
            h-100
            cover
            m_bg_blue
          "
          style="background-image: url('assets/img/layout/bg_login.jpg')"
        >
          <h1 class="title tx--bege">{{ titles[currentStep] }}</h1>
        </div>
        <div
          class="
            home_left
            enter_form
            col--50
            m-100
            flex flex--column flex--center
            center
            m-is--fit
          "
        >
          <LoginForm @changeStep="stepChanged"></LoginForm>
        </div>
      </section>
    </transition>
  </div> -->
</template>

<script>
import LoginForm from "../components/Login/Login.vue";
import EnterPop from "../components/Popups/EnterPop.vue";
import Terms from "../components/Shared/Terms.vue";

export default {
  name: "Login",
  components: { LoginForm, Terms },

  data: function() {
    return {
      loaded: false,
      currentStep: 1,
      titles: {
        1: "MyMedical Doctors",
        2: "MyMedical Doctors",
        3: "ברוכים הבאים"
      }
    };
  },
  mounted() {
    const isMobile = window.innerWidth < 1200;
    const initMobile = localStorage.getItem("init-mobile");
    const initDesktop = localStorage.getItem("init-desktop");
    if (isMobile && !initMobile && navigator.userAgent != "hmcAppUserAgent") {
      localStorage.setItem("init-mobile", true);
      this.$modal.show(EnterPop, { step: "init-mobile" });
    } else if (!isMobile && !initDesktop) {
      localStorage.setItem("init-desktop", true);
      this.$modal.show(EnterPop, { step: "init-desktop" });
    }
    this.loaded = true;
  },
  methods: {
    stepChanged(value) {
      this.currentStep = value.step;
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
